( () => {

    const debug = ( ...args ) => window.barn2.methods.run( 'debug',...args );

    const priceFormatter = new Intl.NumberFormat( 'en-US', {
        maximumFractionDigits: 0
    } );

    const getCurrentCurrency = () => {

        const localizedCurrencyFormats = window.barn2.get( 'formatting' ) ?? {};

        let currency = window.barn2.get('user.currency')?.toUpperCase();
        if ( ! currency || currency === 'XX' || ! localizedCurrencyFormats[ currency ] ) {
            currency = 'USD';
        }

        const format = localizedCurrencyFormats[ currency ] ?? { symbol: '$' };
        format.currency = currency;

        return format;

    }

    const resetPriceLabel = ( productId, priceId, priceGroup, priceLabel, setProperties = true ) => {

        const localizedProductPrices   = window.barn2.get( `prices.${productId}` ) ?? {};

        if ( ! localizedProductPrices ) {
            //document.addEventListener( 'onProductsLoadSuccess', () => resetDiscountFlag( productId, priceId, domParent ) );
            window.barn2.methods.runOnce('getProducts');
            return;
        }

        const currentFormat = getCurrentCurrency();
        const currency = currentFormat.currency;

        const withSuffix = currentFormat.suffix ? ` ${currentFormat.suffix}` : '';

        const currentPrice = localizedProductPrices[ priceId ]?.current?.[ currency ] ?? null;
        if ( ! currentPrice ) {
            return;
        }

        const previousPrice = localizedProductPrices?.[priceId]?.previous?.[currency] ?? null;
        const originalPrice = localizedProductPrices?.[priceId]?.original?.[currency] ?? null;
        const priceSavings = localizedProductPrices?.[priceId]?.savings?.[currency] ?? null;

        const formatters = {
            // this is "AUD" or "CAD" when applicable
            'price-suffix': ( el, valueOnly = false ) => {
                if ( valueOnly ) {
                    return currentFormat.suffix ?? '';
                }
                withSuffix
                    ? el.parentNode.classList.remove( 'is-style-hidden-currency' )
                    : el.parentNode.classList.add( 'is-style-hidden-currency' );
                return withSuffix;
            },
            // the price to display
            'price-current': ( el, valueOnly = false ) => {
                if ( valueOnly ) {
                    return currentPrice;
                }
                const divisor = parseInt( el.closest('[data-payment-divisor]')?.dataset?.paymentDivisor ?? 1 );
                const value = Math.floor( currentPrice / divisor );
                return el.dataset.priceCurrent === 'value' ? value : priceFormatter.format( value ) + withSuffix;
            },
            // the actual price (in case of a monthly display)
            'price-billed':  ( el ) => {
                return el.dataset.priceBilled === 'value'
                        ? currentPrice
                        : `Billed as <sup>${currentFormat.symbol}</sup>${currentPrice}<sub>${withSuffix}</sub>  per year`;
            },
            // the price pre-discount
            'price-previous': ( el, valueOnly = false ) => {
                if ( valueOnly ) {
                    return previousPrice;
                }
                if ( previousPrice ) {
                    return el.dataset.pricePrevious === 'value'
                        ? priceFormatter.format( previousPrice )
                        : `<sup>${currentFormat.symbol}</sup><span>${priceFormatter.format( previousPrice )}</span>`
                }
                return null;
            },
            // the value of a bundle
            'price-original': ( el, valueOnly = false ) => {
                if ( valueOnly ) {
                    return originalPrice;
                }
                if ( originalPrice ) {
                    return el.dataset.pricePrevious === 'value'
                        ? priceFormatter.format(price)
                        : `<sup>${currentFormat.symbol}</sup><span>${priceFormatter.format(originalPrice)}</span>`
                }
                return null;
            },
            // the discount savings
            'price-savings': ( el, valueOnly = false ) => {
                if ( ! previousPrice ) {
                    if ( ! valueOnly ) {
                        el.classList.add('is-style-hidden');
                    }
                    return '';
                }
                const savingsAmount = previousPrice - currentPrice;
                if ( savingsAmount && valueOnly ) {
                    return Math.trunc( savingsAmount );
                }

                const savingsPercent = Math.floor( 100.0 * parseFloat( savingsAmount ) / parseFloat( previousPrice ) );
                const template = el.dataset.template ?? '(save <sup>{currency}</sup><span>{amount}</span>)';
                if ( savingsAmount < 0 || ! priceSavings || priceSavings < 20 ) {
                    el.classList.add('is-style-hidden');
                } else {
                    el.classList.remove('is-style-hidden');
                }
                return template
                    .replace( '$$', currentFormat.symbol + Math.trunc( savingsAmount ) )
                    .replace( '{amount}', Math.trunc( savingsAmount ) )
                    .replace( '{currency}', currentFormat.symbol )
                    .replace( '%%', Math.trunc( savingsPercent ) + '%' )
                    .replace( '{percent}', Math.trunc( savingsPercent ) + '%' )
            },
            // the price symbol
            'price-symbol': () => { return currentFormat.symbol }
        }

        if ( setProperties ) {
            priceLabel.querySelectorAll('[data-price-id]').forEach(el => el.dataset.priceId = priceId);
        }

        for (const dataSelector in formatters) {
            const callback = formatters[dataSelector];
            const priceData = priceLabel.querySelectorAll(`[data-${dataSelector}]`);
            priceData.forEach(el => {
                if ( ['formatted','value',''].includes( el.getAttribute('data-' + dataSelector) ) ) {
                    const mutated = callback( el, false );
                    if (mutated) {
                        el.innerHTML = mutated;
                    }
                } else if ( setProperties ) {
                    const mutated = callback( el, true );
                    if ( mutated ) {
                        el.setAttribute('data-' + dataSelector,mutated);
                    }
                }
            });
        }

        resetDiscountFlag( productId, priceId, priceLabel.closest('[data-role="variable-price-options"]') );

    }


    const updateCartLinks = ( productId, newPriceId, wasPrice = null, scope = document ) => {
        const links = ( ( scope.tagName ?? null ) === 'A' )
            ? [ scope ]
            : scope.querySelectorAll(`a[href*="edd_action=add_to_cart"][href*="download_id=${productId}"]`);
        for ( const link of links ) {
            const url = new URL( link.href );
            const productId = url.searchParams.get('download_id');
            const priceId   = url.searchParams.get('edd_options[price_id]');
            if ( wasPrice && parseInt( priceId ) !== parseInt( wasPrice ) ) {
                continue;
            }

            url.searchParams.set( 'download_id', productId );
            url.searchParams.set( 'edd_options[price_id]', newPriceId );

            link.href = url.toString();
            link.dataset.productId = productId;
            link.dataset.priceId = newPriceId;
            link.dataset.role = 'add-to-cart-button';
            debug( 'installed cart link on', link );
        }
    }
    window.barn2.methods.new( 'updateCartLinks', updateCartLinks );

    const installProductPrices = ( productId, newPrices ) => {

        window.barn2.save( { prices: { [productId]: newPrices } }, window.sessionStorage );

        document.dispatchEvent( new Event( 'onPricesInstalled' ) );
        for( const priceId in newPrices ) {
            document.dispatchEvent(new CustomEvent('onPriceDataReady', {
                detail: {
                    productId,
                    priceId
                }
            }));
        }

    }


    const updateVariationPrices = ( productId, priceId, currentPrices, originalPrices, previousPrices ) => {

        let currency = window.barn2.get( 'user.currency' );
        if ( ! currency ) {
            document.addEventListener( 'onCurrencyLocalized', () => {
                updateVariationPrices( productId, priceId, currentPrices, originalPrices, previousPrices );
            } );
            return;
        }

        window.barn2.save( {
            prices: {
                [productId]: {
                    [priceId]: {
                        current: currentPrices,
                        original: originalPrices,
                        previous: previousPrices,
                    }
                }
            }
        } );

        document.dispatchEvent( new Event( 'onPriceUpdated' ) );

    }


    const updateFormats = ( formats ) => {

        for( const currencyType in formats ) {
            window.barn2.save( { formatting: { [currencyType]: formats[ currencyType ] } } );
        }

    }
    window.barn2.methods.new( 'installCurrencyFormats', updateFormats );

    const updateCheckoutButtons = ( productId, priceId, priceGroup = null, newLabel = null, scope = document ) => {

        const buttons = scope.querySelectorAll(`[data-role="add-to-cart-button"],a[href*="?edd-action=add_to_cart"]`);
        for ( const button of buttons ) {
            let buttonProductId = button.dataset.productId;
            if ( ! buttonProductId && button.tagName === 'A' ) {
                const urlParams = new URL( button.href );
                buttonProductId = urlParams.searchParams.get('download_id');
            }
            if ( buttonProductId !== productId ) {
                continue;
            }
            if ( button.tagName === 'button' && priceGroup !== ( button.dataset.priceGroup ?? null ) ) {
                continue;
            }
            if ( newLabel ) {
                button.innerHTML = newLabel;
            }
            button.dataset.priceId = priceId;
            // these is here to reset anchor tags:
            button.dataset.productId = productId;
            button.dataset.role = 'add-to-cart-button';
        }

    }

    const refreshPriceData = async () => {

        let currency = window.barn2.get('user.currency');

        if ( ! currency ) {
            debug( 'failed to get user currency, waiting for localization' );
            document.addEventListener( 'onCurrencyLocalized', refreshPriceData );
            return;
        }

        const productIds = new Set();
        document.querySelectorAll('[data-role="price-option-display"]').forEach( el => {
            if ( el.dataset.productId ) {
                const priceData = window.barn2.get(`prices.${el.dataset.productId}`);
                if ( ! priceData ) {
                    productIds.add(el.dataset.productId);
                } else {
                    installProductPrices( el.dataset.productId, priceData );
                    document.dispatchEvent( new CustomEvent( 'onPriceDataReady', { detail: {
                        productId: el.dataset.productId,
                        priceId: el.dataset.priceId
                    } } ) );
                }
            }
        } );

        if ( productIds.size === 0 ) {
            return;
        }

        const coupons = window.barn2.get( 'user.discount' );

        const server = window.barn2.get('endpoints.localization');
        server.pathname = '/wp-json/barn2/v3/pricing/localized';
        server.searchParams = null;

        const fetchUrl = new URL( server );
        fetchUrl.searchParams.set( 'products', Array.from(productIds).join(',') );
        fetchUrl.searchParams.set( 'currency', currency.toUpperCase() );
        if ( coupons ) {
            fetchUrl.searchParams.set( 'discount', coupons );
        }

        try {
            const response = await fetch(fetchUrl);
            if (!response.ok) {
                throw new Error('Network response was not OK');
            }
            const data = await response.json();
            productIds.forEach(download => {
                if (!data[download]) {
                    return;
                }
                installProductPrices(download, data[download].prices);
                debug('localized products for ' + download);
            });
        } catch( error ) {
            console.error( error );
        }

        debug( 'price data refreshed' );

    };


    const foundProductTables = new Map();

    const addToCartAndCheckout = async ( productId, priceId, submitter ) => {

        const localizedProductPrices = window.barn2.products?.[productId] ?? {};

        if ( submitter ) {
            submitter.parentElement.classList.add( 'is-state-loading' );
            submitter.blur();
        }

        if ( typeof gtag !== 'undefined' ) {
            try {
                const product   = window.barn2.get( `products.${productId}` );
                const foundPrice  = localizedProductPrices[priceId].current['USD'];
                gtag( "event", "add_to_cart", {
                    currency: window.barn2.get('user.currency'),
                    value: parseFloat( price ),
                    items: [{
                        item_id:      productId,
                        item_name:    product?.title,
                        item_variant: priceId,
                        price:        parseFloat( foundPrice ),
                    }]
                } );
            } catch(e) {}

        }

        const requestData = {
            'edd_action': 'add_to_cart',
            'download_id': productId,
            'price_id': priceId,
            'timestamp': Date.now()
        };

        try {
            const response = await fetch( window.barn2.get('endpoints.cart'), {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify( requestData ),
            } );
            if ( ! response.ok ) {
                throw response;
            }
            window.location.href = '/checkout/';
        } catch( error ) {
            window.location.href = `/checkout/?edd_action=add_to_cart&download_id=${productId}&edd_options[price_id]=${priceId}`;
        }

    }




    const resetDiscountFlag = ( productId, priceId, domParent = document ) => {

        if ( ! domParent ) {
            return;
        }

        const localizedProductPrices = window.barn2.get( `prices.${productId}` );
        if ( ! localizedProductPrices ) {
            //document.addEventListener( 'onProductsLoadSuccess', () => resetDiscountFlag( productId, priceId, domParent ) );
            window.barn2.methods.run('getProducts');
            return;
        }

        const currentFormat = getCurrentCurrency();

        const discount = localizedProductPrices[ priceId ]?.discounted ?? null;
        const discountFlags = domParent.querySelectorAll( '.price-picker__price-row-discount, .pricing-table__price-row-discount' );
        for( const discountFlag of discountFlags ) {
            if ( ! discount || discount < 0 ) {
                const parent = discountFlag.closest('[data-role="price-option-display"],.show-discount');
                if ( parent ) {
                    parent.classList.remove('show-discount');
                }
                discountFlag.style.display = 'none';
                continue;
            }
            const parent = discountFlag.closest('[data-role="price-option-display"]');
            if ( parent ) {
                parent.classList.add('show-discount');
            }
            discountFlag.style.display = '';
            discountFlag.innerHTML = '';
            discountFlag.innerHTML = discount <= 1
                ? Math.floor( localizedProductPrices[ priceId ].discounted * 100 ) + '%<br>off'
                : currentFormat.symbol + Math.floor( localizedProductPrices[ priceId ].discounted ) + '<br>off';
        }

    }


    document.addEventListener( 'click', ( event ) => {
        const self = event.target.closest(`[data-role="add-to-cart-button"]`);
        if ( ! self ) {
            return;
        }
        event.preventDefault();

        const priceId = self.dataset.priceId;
        const productId = self.dataset.productId;
        document.dispatchEvent( new CustomEvent( 'onAddToCart', { detail: { productId, priceId, submitter: self } } ) );

    } );

    document.addEventListener( 'onProductDurationChanged', ( { detail } ) => {
        const { recurring, products, scope } = detail;
        products.forEach( ( { productId, recurringId, lifetimeId } ) => {
            const displayPrices = scope.querySelectorAll(`[data-role="price-option-display"][data-product-id="${productId}"][data-recurring]`);
            displayPrices.forEach( el => {
                el.setAttribute( 'aria-hidden', ( el.dataset.recurring === recurring ) ? 'true' : 'false' );
                updateCartLinks(
                    productId,
                    recurring === 'yes' ? lifetimeId : recurringId,
                    recurring === 'yes' ? recurringId : lifetimeId,
                    scope
                );
            } );
        } );
    } );


    document.addEventListener( 'onPriceDataReady', ( { detail }) => {
        const { productId = null, priceId = null } = detail;
        let query = `[data-role="price-option-display"]`;
        if ( productId ) {
            query += `[data-product-id="${productId}"]`;
        }
        if ( priceId ) {
            query += `[data-price-id="${priceId}"]`;
        }
        const displayPrices = document.querySelectorAll(query);
        debug( 'onPriceDataReady callback', displayPrices );
        displayPrices.forEach( el => {
            const priceId = el.dataset.priceId ?? el.dataset.defaultPriceId;
            resetPriceLabel( el.dataset.productId, priceId, null, el );
            updateCartLinks( el.dataset.productId, priceId, priceId );
        } );
    } );

    const installPriceSwitcher = () => {

        const priceTables = document.querySelectorAll('.wp-block-barn2-table-grid');
        priceTables.forEach(table => {

            if ( table.classList.contains('has-price-switcher' ) ) {
                return;
            }

            let needsSwitcher = false;
            const columns = table.querySelectorAll('.wp-block-barn2-table-grid__column');
            const foundProducts = new Set();

            columns.forEach(column => {
                const variations = column.querySelectorAll('[data-role="price-option-display"][data-recurring="yes"]');
                for (const variation of variations) {
                    const productId = variation.dataset.productId ?? null;
                    const priceGroup = variation.dataset.priceGroup ?? null;
                    if (productId) {
                        let selector = `[data-role="price-option-display"][data-product-id="${productId}"][data-recurring="no"]`;
                        if (priceGroup) {
                            selector += `[data-price-group="${priceGroup}"]`;
                        }
                        const lifetimePrice = variation.parentElement.querySelector(selector);
                        if (lifetimePrice) {
                            lifetimePrice.setAttribute('aria-hidden', 'true');
                            lifetimePrice.dataset.linkedTo = variation.dataset.priceId;
                            variation.dataset.linkedTo = lifetimePrice.dataset.priceId;
                            needsSwitcher = true;

                            foundProducts.add( {
                                productId,
                                recurringId: variation.dataset.priceId,
                                lifetimeId: lifetimePrice.dataset.priceId,
                                scope: table
                            });
                        }
                    }
                }
            });

            if (needsSwitcher) {
                table.classList.add('has-price-switcher');

                const priceInput = document.createElement('input');
                priceInput.style.display = 'none';
                priceInput.classList.add('product-price-switcher__input');
                priceInput.type = 'checkbox';
                table.insertAdjacentElement('beforebegin', priceInput);

                const priceSwitcher = document.createElement('div');
                priceSwitcher.classList.add('product-price-switcher__buttons');
                priceSwitcher.innerHTML = `
                    <button class="product-price-switcher__button" data-switch="yearly">Yearly</button>
                    <span class="product-price-switcher__switch-graphic"></span>
                    <button class="product-price-switcher__button" data-switch="lifetime">Lifetime</button>
                `;
                priceSwitcher.addEventListener('click', () => {
                    priceInput.checked = !priceInput.checked;
                    document.dispatchEvent(new CustomEvent('onProductDurationChanged', {
                        detail: {
                            scope: table,
                            recurring: priceInput.checked ? 'yes' : 'no',
                            products: foundProducts
                        }
                    }));
                });
                table.insertAdjacentElement('beforebegin', priceSwitcher);
            }

            foundProductTables.set(table, foundProducts);

        });

    }


    if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {
        installPriceSwitcher();
        refreshPriceData();
        resetPriceLabel();
    } else {
        document.addEventListener( 'DOMContentLoaded', installPriceSwitcher );
        document.addEventListener( 'DOMContentLoaded', refreshPriceData );
        document.addEventListener( 'DOMContentLoaded', resetPriceLabel );

    }

    window.barn2.methods.new( 'resetPriceLabel', resetPriceLabel );
    window.barn2.methods.new( 'updateVariationPrices', updateVariationPrices );
    window.barn2.methods.new( 'installProductPrices', installProductPrices );
    window.barn2.methods.new( 'updateCheckoutButtons', updateCheckoutButtons );
    window.barn2.methods.new( 'refreshPriceData', refreshPriceData );
    window.barn2.methods.new( 'addToCartAndCheckout', addToCartAndCheckout );
    window.barn2.methods.new( 'resetDiscountFlag', resetDiscountFlag );

    document.dispatchEvent( new Event( 'onProductDataLoaded' ) );

} )();